// src/MapsProvider.jsx
import { LoadScript } from "@react-google-maps/api";

const LIBRARIES = ["places"]; // mantenha fixo

export default function MapsProvider({ children }) {
  return (
    <LoadScript
      id="google-maps" // id único e estável
      googleMapsApiKey={"AIzaSyDNZ5JW-VEniKiFdSoySNFQdyhuaOu9YIc"}
      libraries={LIBRARIES}
      language="pt-BR"
      region="BR"
      // version="weekly" // opcional, mas não mude em nenhum lugar
    >
      {children}
    </LoadScript>
  );
}
